import { Link } from "react-router-dom";
import { t } from "../../content";
import Button from "../../components/reusableElementsComponents/Button";
import LanguageSwitcher from "../../components/layoutComponents/LanguageSwitcher";
import { useLocale } from "../../locale";

function ErrorPage() {
  const { withLocale } = useLocale();

  return (
    <div className="error-page center-content">
      <div className="error-page__lang">
        <LanguageSwitcher variant="auth" />
      </div>
      <h1 className="error-message font-rounded semi-bold">
        {t("errors.notFound.title")}
      </h1>
      <Button btnstyle={"mazhrBtn default-green-border"}>
        <Link to={withLocale("/login")}>{t("errors.notFound.backHome")}</Link>
      </Button>
    </div>
  );
}

export default ErrorPage;
